<!-- 管理员总页面 -->
<template>
    <router-view v-if="$route.path !== '/devsetting'"></router-view>
    <div class="practical-table" v-else ref="scrollableDiv">
        <!-- 判断是否是管理员 -->
        <div class="container card" v-if="sisadmin">
            <el-tabs v-model="activeName" @tab-click="tabpanclick">
                <!-- 暗拍卖场 -->
                <el-tab-pane label="暗拍卖场" name="treasure" style="padding-top: 25px">
                    <treasureView></treasureView>
                </el-tab-pane>
                <!-- 注册账号 -->
                <el-tab-pane label="账号注册" name="register">
                    <div>
                        <h1 style="color: white">
                            注册
                            <button @click.prevent="handleregister" style="margin-left: 12px">前往采货估价系统账号注册</button>
                        </h1>
                    </div>
                </el-tab-pane>
                <!-- 任务列表 -->
                <el-tab-pane label="任务模板" name="tasklist">
                    <taskListView ref="taskListViewRef"></taskListView>
                </el-tab-pane>
                <!-- 任务情况 -->
                <el-tab-pane label="任务情况" name="taskcondition">
                    <taskconditionView></taskconditionView>
                </el-tab-pane>
                <!-- 老的出价统计 -->
                <el-tab-pane label="每日情况" name="1">
                    <DailyStatistics ref="dailyStatisticsRef"></DailyStatistics>
                </el-tab-pane>
                <!-- 平台启用 -->
                <el-tab-pane label="平台设置" name="2">
                    <div>
                        <button @click="theplatform">刷新</button>
                        <div class="form-group">
                            <el-table :data="selectdata">
                                <!-- 展示 -->
                                <el-table-column label="id" width="55px">
                                    <template #default="scope">
                                        {{ scope.row.id }}
                                    </template>
                                </el-table-column>
                                <!-- 展示 -->
                                <el-table-column label="paramValue" width="155px">
                                    <template #default="scope">
                                        {{ scope.row.paramValue }}
                                    </template>
                                </el-table-column>
                                <!-- 展示 -->
                                <el-table-column label="paramDescriptions">
                                    <template #default="scope">
                                        {{ scope.row.paramDescriptions }}
                                    </template>
                                </el-table-column>
                                <!-- 启用 -->
                                <el-table-column label="平台展示启用">
                                    <template #default="scope">
                                        <span v-if="scope.row.systemConfigStatus === 0">启用</span>
                                        <span v-if="scope.row.systemConfigStatus === 1">关闭</span>
                                        <el-switch
                                            v-model="scope.row.systemConfigStatus"
                                            :active-value="0"
                                            :inactive-value="1"
                                            @change="handleplatformOnOff(scope.row.id, scope.row.systemConfigStatus)"
                                            style="margin-left: 14px" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- 账号启用 -->
                <el-tab-pane label="账号启用" name="3">
                    <div>
                        <div class="form-group">
                            <el-form :inline="true" :model="formData">
                                <el-form-item label="">
                                    <el-input v-model="formData.nickName" placeholder="用户名" clearable />
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input v-model="formData.phone" placeholder="手机号" clearable />
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="searchUser()">查询</el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="managerSetting"> 刷新 </el-button>
                                </el-form-item>
                            </el-form>
                            <el-table :data="managerList">
                                <!-- 展示 -->
                                {{ managerList }}
                                <el-table-column label="用户名" min-width="200px">
                                    <template #default="scope">
                                        {{ scope.row.nickName }}
                                    </template>
                                </el-table-column>
                                <!-- 展示 -->
                                <el-table-column label="手机号" min-width="200px">
                                    <template #default="scope">
                                        {{ scope.row.phone }}
                                    </template>
                                </el-table-column>
                                <!-- 展示 -->
                                <el-table-column label="avatar" min-width="200px">
                                    <template #default="scope">
                                        {{ scope.row.avatar }}
                                    </template>
                                </el-table-column>
                                <!-- 启用 -->
                                <el-table-column label="管理员启用" min-width="200px">
                                    <template #default="scope">
                                        <span v-if="scope.row.status === 0">启用</span>
                                        <span v-if="scope.row.status === 1">禁用</span>

                                        <el-switch
                                            v-model="scope.row.status"
                                            :active-value="0"
                                            :inactive-value="1"
                                            @change="handleToggle(scope.row.idString, scope.row.status)"
                                            style="margin-left: 14px" />
                                    </template>
                                </el-table-column>
                                <!-- 操作列 -->
                                <el-table-column label="操作" header-align="center" align="center">
                                    <template v-slot="scope">
                                        <el-button type="primary" @click="handleEdit(scope.row)">修改</el-button>
                                        <el-button type="danger" @click="handleDelete(scope.row.idString)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 修改密码 -->
                            <el-dialog title="修改密码" v-model="dialogPassword">
                                <el-form :model="formPassword">
                                    <el-form-item label="旧密码">
                                        <div>{{ password }}</div>
                                    </el-form-item>
                                    <el-form-item label="新密码">
                                        <el-input style="width: 200px" v-model="formPassword.password" autocomplete="off"></el-input>
                                    </el-form-item>
                                </el-form>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="dialogPassword = false">取 消</el-button>
                                    <el-button type="primary" @click="dialogPasswordHandle">确 定</el-button>
                                </div>
                            </el-dialog>
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[100, 200, 300, 400]"
                                :page-size="itemsPerPage"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="allPages">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <!-- 采货侠历史成交 -->
                <el-tab-pane label="采货侠历史" name="4">
                    <div>
                        <h1 style="color: white">采货侠历史成交<button @click.prevent="historyView" style="margin-left: 12px">查看</button></h1>
                        <hr style="margin-top: 25px; margin-bottom: 25px" />
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div v-else style="color: aliceblue; font-size: 99px">出错啦!!请尝试刷新页面.. 点此返回/</div>
        <!-- <FixedButtons @scroll-to-top="scrollToTop" /> -->
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import { changeToPath } from "@/utils/utils";
    import taskconditionView from "@/views/details/taskconditionView.vue";
    import treasureView from "@/views/goodslist/treasureView.vue";
    import axios from "axios";
    import { ElSwitch } from "element-plus";
    import taskListView from "./compoments/taskModelView.vue";
    import DailyStatistics from "@/views/details/compoments/DailyStatisticsView.vue";

    export default {
        name: "PracticalTableView",
        components: { DailyStatistics, FixedButtons, ElSwitch, taskListView, taskconditionView, treasureView },
        data() {
            return {
                sisadmin: localStorage.authRoleVOList.includes("管理员"),

                activeName: "register",
                password: "",
                dialogPassword: false,
                formPassword: {
                    password: "",
                    passwordId: "",
                },
                anyshow: false,
                onoffplatformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",
                switchURL: "/api/systemConfig/disableOrEnable",
                userAll: "/api/user/queryAllUser",
                managerSet: "/api/user/updateUserStatus",
                deleteManager: "/api/user/deleteUserById",
                editPasswordURL: "/api/user/adminResetPassword",
                momo: {
                    pageNo: 1,
                    pageSize: 100,
                    total: 1,
                },
                testshow: process.env.VUE_APP_SHOW === "true",
                // el 表格
                sname: localStorage.nickname,
                selectdata: null,

                scrollableDiv: null,
                currentPage: 1, // 当前页码
                itemsPerPage: 10, // 每页显示条目数
                allPages: 1, // 总页数
                formData: {
                    nickName: "", // 用户名
                    phone: "", // 手机号
                },
                managerList: [], //管理员列表
            };
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
        },
        methods: {
            //点击标签事件
            tabpanclick(tab, event) {
                if (tab.paneName == 1) {
                    if (this.$refs.dailyStatisticsRef) {
                        this.$refs.dailyStatisticsRef.getSearchParamsInit();
                    }
                } else if (tab.paneName == 2) {
                    this.theplatform();
                } else if (tab.paneName == 3) {
                    this.managerSetting();
                } else if (tab.paneName == "tasklist") {
                    if (this.$refs.taskListViewRef) {
                        this.$refs.taskListViewRef.nowtabInit();
                    }
                }
            },
            //  采货侠历史出价页面
            historyView() {
                changeToPath(this.$router, "/purhistory");
            },

            handleplatformOnOff(a, b) {
                axios.put(
                    this.switchURL,
                    {
                        id: a,
                        systemConfigStatus: b,
                    },
                    {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    }
                );
            },

            //点击注册按钮，跳转至注册页面
            handleregister: function () {
                this.$router.replace("/register");
            },

            // 页面底部
            scrollToBottom() {
                this.scrollableDiv.scrollTo({
                    top: this.scrollableDiv.scrollHeight,
                    behavior: "auto",
                });
            },

            // 开关平台
            theplatform() {
                let a = localStorage.sa;

                axios
                    .get("/api/systemConfig/queryBySystemConfigSearchDTO", {
                        headers: {
                            satoken: a,
                        },
                    })
                    .then((response) => {
                        this.selectdata = response.data.data.result;
                        // 输出响应数据
                    })
                    .catch((error) => {
                        this.selectdata = error;
                        console.error("获取数据出错:", error);
                    });
            },

            //查询用户
            searchUser() {
                this.getManagerList();
            },
            //管理员列表
            getManagerList() {
                axios
                    .get(this.userAll, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            ...this.formData,
                        },
                    })
                    .then((res) => {
                        this.allPages = res.data.data.total;
                        this.managerList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerPage = val;
                this.getManagerList();
            },
            //改变页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getManagerList();
            },
            //切换禁用
            handleToggle(id, status) {
                this.toggle(id, status);
            },
            toggle(id, status) {
                axios
                    .post(
                        this.managerSet,
                        {
                            id,
                            status,
                        },
                        {
                            headers: {
                                satoken: localStorage.sa,
                            },
                        }
                    )
                    .then((res) => {
                        this.$message({
                            message: res.data.data,
                            type: "success",
                        });
                    })
                    .catch((error) => {
                        console.error("获取数据出错:", error);
                    });
            },
            //修改密码
            handleEdit(row) {
                this.formPassword.password = "";
                this.dialogPassword = true;
                this.password = row.password;
                this.formPassword.passwordId = row.idString;
            },
            //修改密码
            dialogPasswordHandle() {
                let params = {};
                params.id = this.formPassword.passwordId;
                params.password = this.formPassword.password;
                axios
                    .put(this.editPasswordURL, params, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                    })
                    .then((res) => {
                        if (res.data.success) {
                            this.$message({
                                message: res.data.data,
                                type: "success",
                            });
                            this.dialogPassword = false;
                            this.getManagerList();
                        } else {
                            this.$message.error(res.data.message);
                        }
                    });
            },
            handleDelete(row) {
                try {
                    this.$confirm("确认删除当前用户?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.deleteManager + `?id=${row}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.data,
                                            type: "success",
                                        });
                                        this.getManagerList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },
            // 点击管理员设置
            managerSetting() {
                this.getManagerList();
            },
        },
        watch: {},
        computed: {
            //
        },

        mounted() {
            if (this.sisadmin) {
                //
            } else {
                // 跳转到首页并刷新页面
                this.$router.push("/"); // 跳转到首页
            }
        },
    };
</script>

<style lang="scss" scoped>
    /* 表格样式*/
    .el-table {
        justify-content: center;
        --el-table-header-bg-color: rgb(107, 107, 107);
        --el-table-text-color: #000000;
        --el-table-border: 1px solid #ebeef5;
    }

    .addone {
        width: 100%;
        justify-content: center;
        display: flex;
        background-color: aliceblue;
        border-radius: 0 0 20px 20px;
    }

    ul {
        padding: 0;

        li {
            list-style-type: none;
            margin-bottom: 15px;
        }
    }

    .practical-table {
        width: 100%;
        padding: 20px 40px;
        overflow: auto;
        // color: #ffffff;
    }

    .card {
        background-color: transparent;
        border: 1px solid transparent;
    }

    .form-control {
        background-color: #ded9d9;
        margin: 0;
    }

    .thead-dark {
        background-color: #585d6b;
        color: white;
    }

    .form-group {
        margin-bottom: 25px;
    }

    :deep(.tiptop) {
        position: relative;
    }

    :deep(.tiptop .el-icon) {
        color: #ffffff;
        position: absolute;
        top: -53px;
        left: 215px;
    }

    :deep(.el-pagination > .is-first) {
        color: #ffffff;
    }

    :deep(.el-pagination__goto) {
        color: #ffffff;
    }

    :deep(.el-pagination__classifier) {
        color: #ffffff;
    }

    :deep(.el-pagination) {
        margin-top: 20px;
    }

    :deep(.el-tabs__item) {
        color: #ffffff;
    }
</style>
